import type { ProbationQuestion } from "../schemas/index.ts";

export function isProbationSectionSubmitted(questions: ProbationQuestion[]): boolean {
  return questions.length > 0 && questions[0].status === "SUBMITTED";
}

export function isProbationSectionDraft(questions: ProbationQuestion[]): boolean {
  return questions.length > 0 && questions[0].status === "DRAFT";
}

/** True when the section has not been submitted and has no saved draft. */
export function isProbationSectionPending(questions: ProbationQuestion[]): boolean {
  if (questions.length === 0) return true;
  return !isProbationSectionSubmitted(questions);
}
